import React from 'react';
import {
  IconBulletedListFilled,
  IconCartOutlined,
  IconHomeOutlined,
  IconLeadsOutlined,
  IconReportsOutlined,
} from '@gafe/common-ui';

import { TabName } from '@/pages/Dashboard/ActivityList/helpers';

export const getTabsToRender = [
  {
    name: TabName.Home,
    icon: (
      <IconHomeOutlined
        height={{ desktop: 'sm', tablet: 'xs' }}
        width={{ desktop: 'sm', tablet: 'xs' }}
      />
    ),
  },
  {
    name: TabName.Leads,
    icon: (
      <IconLeadsOutlined
        height={{ desktop: 'sm', tablet: 'xs' }}
        width={{ desktop: 'sm', tablet: 'xs' }}
      />
    ),
  },
  {
    name: TabName.Orders,
    icon: (
      <IconCartOutlined
        height={{ desktop: 'sm', tablet: 'xs' }}
        width={{ desktop: 'sm', tablet: 'xs' }}
      />
    ),
  },
  {
    name: TabName.Projects,
    icon: (
      <IconBulletedListFilled
        height={{ desktop: 'sm', tablet: 'xs' }}
        width={{ desktop: 'sm', tablet: 'xs' }}
      />
    ),
  },
  {
    name: TabName.Reports,
    icon: (
      <IconReportsOutlined
        height={{ desktop: 'sm', tablet: 'xs' }}
        width={{ desktop: 'sm', tablet: 'xs' }}
      />
    ),
  },
];
